export default __webpack_public_path__ + "static/mapa-desk-8780ad47d9742c32b9f34214caa21a47.svg";